// extracted by mini-css-extract-plugin
export var container = "_ie-0";
export var content = "_ie-3";
export var customerTitle = "_ie-4";
export var empty = "_ie-5";
export var gray = "_ie-6";
export var header = "_ie-7";
export var info = "_ie-8";
export var loading = "_ie-2";
export var loadingCard = "_ie-9";
export var oneLine = "_ie-a";
export var personName = "_ie-e";
export var pillContainer = "_ie-b";
export var selected = "_ie-1";
export var text = "_ie-c";
export var twoLines = "_ie-d";
export var unread = "_ie-f";
export var unreadIndicator = "_ie-g";